import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrl: './dialog.component.scss',
})

/**
 * The component that displays an dialog
 */
export class DialogComponent {
    @Input() header: string;
    @Input() closeButtonText: string;
    @Input() confirmButtonText: string;
}
